module.exports = __webpack_public_path__ + "static/media/giphy.b94a2ce2.gif";